import {CardBack, CardHole} from "./CardBacks";
import {CardImage} from "./CardImage";
import {Template} from "./Templates";

export class CreatingCard {
  id: number;
  cardImage: CardImage[] = [];
  cardText: CardImage[] = [];
  cardHoles: CardHole[] = [];
  cardBack: CardBack = null;
  template: Template = null;

  constructor(id: number, images: CardImage[], text: CardImage[], holes: CardHole[], back: CardBack) {
    this.id = id;
    this.cardImage = images;
    this.cardText = text;
    this.cardHoles = holes;
    this.cardBack = back;
  }
}
